module.exports = __webpack_public_path__ + "img/main_visual_5.a2405525.jpg";